import { render } from "./submission-panel-supporter-interests.vue?vue&type=template&id=f6c01444&scoped=true&ts=true"
import script from "./submission-panel-supporter-interests.vue?vue&type=script&lang=ts"
export * from "./submission-panel-supporter-interests.vue?vue&type=script&lang=ts"

import "./submission-panel-supporter-interests.vue?vue&type=style&index=0&id=f6c01444&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c01444"]])

export default __exports__